app.factory('meedyALABModel', ['$rootScope', 'baseModel', 'meedyALABService',
    function($rootScope, baseModel, meedyALABService) {

        function MeedyALABModel() {

            this.getDataPage = function(criteria) {
                return meedyALABService.getDataPage(criteria).then(
                    function (dataPage) {
                        return dataPage;
                    },
                    function(error) {
                        //
                    }
                );
            };

            this.getResources = function(offers) {
                return meedyALABService.getResources(offers).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function(error) {
                        //
                    }
                );
            };

        }

        return new MeedyALABModel();
    }
]);
